export const META_URL_SITE =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000"
    : "https://project-status.org"
